export default __webpack_public_path__ + "1.19.3/static/media/libreLinkUp.07cb949d.svg";